import React from 'react';
import { CheckCircle2, XCircle, AlertTriangle, Info, X } from 'lucide-react';
import { Toast, ToastType } from '../../contexts/ToastContext';
import './ToastContainer.css';

const TYPE_META: Record<ToastType, { color: string; Icon: React.FC<{ size: number; color: string }> }> = {
  success: { color: '#22c55e', Icon: CheckCircle2 },
  error: { color: '#ef4444', Icon: XCircle },
  warning: { color: '#f59e0b', Icon: AlertTriangle },
  info: { color: '#3b82f6', Icon: Info },
};

interface ToastContainerProps {
  toasts: Toast[];
  onDismiss: (id: string) => void;
}

export const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onDismiss }) => {
  if (!toasts.length) return null;

  return (
    <div className="toast-stack" aria-live="polite" aria-atomic="false">
      {toasts.map(toast => {
        const { color, Icon } = TYPE_META[toast.type];
        return (
          <div key={toast.id} className={`toast toast--${toast.type}`} role="alert">
            <span className="toast-bar" style={{ background: color }} />
            <span className="toast-icon"><Icon size={16} color={color} /></span>
            <span className="toast-message">{toast.message}</span>
            <button
              className="toast-dismiss"
              onClick={() => onDismiss(toast.id)}
              aria-label="Dismiss"
              type="button"
            >
              <X size={13} />
            </button>
          </div>
        );
      })}
    </div>
  );
};
